import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  protected urlPath = '/v1';

  constructor(protected _http: HttpClient) {
  }

  protected getFullUrl(endpoint: string): string {
    return `${this.urlPath}/${endpoint}`;
  }
}
